import { startG3Telemetry } from './g3-telemetry/index.js';
import './style.css';

startG3Telemetry({
  ingestUrl: G3_INGEST_URL,
  reportToken: G3_REPORT_TOKEN,
  commit: G3_COMMIT_SHA,
  deployUrl: G3_DEPLOY_URL,
});

const $ = (id) => document.getElementById(id);
const list = $('list'), err = $('error'), empty = $('empty'), form = $('add');

async function api(path, method = 'GET', body) {
  const r = await fetch('/api/counters' + path, {
    method,
    headers: body ? { 'content-type': 'application/json' } : undefined,
    body: body && JSON.stringify(body),
  });
  if (!r.ok && r.status !== 404) throw new Error(`${method} failed (${r.status})`);
  return r;
}

function button(text, label, onClick) {
  const b = document.createElement('button');
  b.className = text === '+' ? 'inc' : text === '\u2715' ? 'del' : 'dec';
  b.textContent = text; b.setAttribute('aria-label', label);
  b.addEventListener('click', onClick);
  return b;
}

const hue = (s) => [...String(s)].reduce((h, ch) => (h * 31 + ch.charCodeAt(0)) % 360, 7);
const rows = new Map();

function makeRow(c) {
  const li = document.createElement('li');
  li.style.setProperty('--h', hue(c.name));
  const name = document.createElement('span'); name.className = 'name'; name.textContent = c.name;
  const value = document.createElement('span'); value.className = 'value';
  li.append(name, value,
    button('\u2212', `Decrement ${c.name}`, () => act(`/${c.id}`, 'PATCH', { delta: -1 })),
    button('+', `Increment ${c.name}`, () => act(`/${c.id}`, 'PATCH', { delta: 1 })),
    button('\u2715', `Delete ${c.name}`, () => confirm(`Delete "${c.name}"?`) && act(`/${c.id}`, 'DELETE')));
  return li;
}

// Rows are updated in place so a click does not replay the entrance animation (the API orders by id, so new rows go last).
function render(counters) {
  empty.hidden = counters.length > 0;
  const ids = new Set(counters.map((c) => c.id));
  for (const [id, li] of rows) if (!ids.has(id)) { li.remove(); rows.delete(id); }
  for (const c of counters) {
    let li = rows.get(c.id);
    if (!li) { li = makeRow(c); rows.set(c.id, li); list.append(li); }
    const value = li.querySelector('.value');
    const text = String(c.value);
    if (value.textContent !== text) {
      if (value.textContent) { value.classList.remove('bump'); void value.offsetWidth; value.classList.add('bump'); }
      value.textContent = text;
    }
    li.querySelector('.dec').disabled = c.value <= 0;
  }
}

async function load() {
  try { render(await (await api('')).json()); err.textContent = ''; }
  catch (e) { err.textContent = e.message; }
}

async function act(path, method, body) {
  try { await api(path, method, body); } catch (e) { err.textContent = e.message; return false; }
  await load();
  return true;
}

form.addEventListener('submit', async (e) => {
  e.preventDefault();
  if (await act('', 'POST', { name: form.elements.name.value })) form.reset();
});

load();

document.addEventListener('click', (e) => {
  const b = e.target.closest('button');
  if (!b) return;
  b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
});
